import {
  ErrorUIToastMessageCategory,
  InfoUIToastMessageCategory,
  PinnaklUIToastMessageAPI,
  SuccessUIToastMessageCategory,
  WarningUIToastMessageCategory,
} from '@pinnakl/shared/types';

export abstract class PinnaklUIToastMessage implements PinnaklUIToastMessageAPI {
  error(_msg: string, _category?: ErrorUIToastMessageCategory, _options?: any): void {
    throw new Error('Method not implemented.');
  }

  info(_msg: string, _category?: InfoUIToastMessageCategory, _options?: any): void {
    throw new Error('Method not implemented.');
  }

  success(_msg: string, _category?: SuccessUIToastMessageCategory, _options?: any): void {
    throw new Error('Method not implemented.');
  }

  warning(_msg: string, _category?: WarningUIToastMessageCategory, _options?: any): void {
    throw new Error('Method not implemented.');
  }
}
